/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resume_Editor_AppearanceInputs */

const en_resume_editor_appearance = /** @type {(inputs: Resume_Editor_AppearanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Appearance`)
};

const de_resume_editor_appearance = /** @type {(inputs: Resume_Editor_AppearanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Darstellung`)
};

const fr_resume_editor_appearance = /** @type {(inputs: Resume_Editor_AppearanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apparence`)
};

const es_resume_editor_appearance = /** @type {(inputs: Resume_Editor_AppearanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apariencia`)
};

const it_resume_editor_appearance = /** @type {(inputs: Resume_Editor_AppearanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aspetto`)
};

const nl_resume_editor_appearance = /** @type {(inputs: Resume_Editor_AppearanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uiterlijk`)
};

const pl_resume_editor_appearance = /** @type {(inputs: Resume_Editor_AppearanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyglad`)
};

const fi_resume_editor_appearance = /** @type {(inputs: Resume_Editor_AppearanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ulkoasu`)
};

const da_resume_editor_appearance = /** @type {(inputs: Resume_Editor_AppearanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Udseende`)
};

const sv_resume_editor_appearance = /** @type {(inputs: Resume_Editor_AppearanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utseende`)
};

/**
* | output |
* | --- |
* | "Appearance" |
*
* @param {Resume_Editor_AppearanceInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const resume_editor_appearance = /** @type {((inputs?: Resume_Editor_AppearanceInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resume_Editor_AppearanceInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_resume_editor_appearance(inputs)
	if (locale === "fr") return fr_resume_editor_appearance(inputs)
	if (locale === "es") return es_resume_editor_appearance(inputs)
	if (locale === "it") return it_resume_editor_appearance(inputs)
	if (locale === "nl") return nl_resume_editor_appearance(inputs)
	if (locale === "pl") return pl_resume_editor_appearance(inputs)
	if (locale === "fi") return fi_resume_editor_appearance(inputs)
	if (locale === "da") return da_resume_editor_appearance(inputs)
	if (locale === "sv") return sv_resume_editor_appearance(inputs)
	return en_resume_editor_appearance(inputs)
});